import { ClientRuntime as o } from "./index48.js";
const n = new o(), t = n.info, i = t.isMobile;
export {
  t as CLIENT_INFO,
  n as CLIENT_RUNTIME,
  i as IS_MOBILE_DEVICE
};
